const custom_client = {
    custom_favicons: true,
    default: {},
};

export default custom_client;
